import React, { useEffect, useState } from "react";
import cls from "./style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import List from "../../../../../listing/components/list";
import { fetchMePageYouLikes } from "../../../../../../../api";
import { useRef } from "react";
import { useCallback } from "react";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { Iconfont } from "../../../../../../components/icon/iconfont";
import { FormattedMessage } from "react-intl";
import _ from "lodash";
import { action_append_wishlist, action_init_wishlist } from "../../../../../../../store/actions/pages/customer";
import { getByProductIds } from "../../../../../../../api";
import Cache from "../../../../../../../utils/cache";
import { BigButton } from "../../../../../../components/button";
import ProductYouLikes from "../../../../../details/module/youlikes";


const RecentlyViewEmpty = props =>{

    return <div className={cls.RecentlyViewEmpty}>
        <p className={cls.Message}><FormattedMessage id="you_not_recently_view" defaultMessage="You have not viewed anything." /></p>

        <div className={cls.BtnContainer}>
            <BigButton onClick={() =>{
                window.location.href = "/";
            }}><FormattedMessage id="go_shopping" defaultMessage="Go Shopping" />
            </BigButton>
        </div>

        <ProductYouLikes
            titleStyle={{marginTop:0, paddingTop:0}}
            titleClass={'titleLine'}
            noBorderTop={true}
            sensors={{
                resourcepage_title: 'me',
                resource_position: "1",
                resource_type: "4",
                resource_content: "You may also like",
            }}
            />
    </div>
}

const WishListNotLogin = props =>{
    const { onlyCheckoutLoginHandle, isLoginEmpty } = props;

    return <div className={cls.WishListNotLogin}>
        {/* <div className={cls.WishIcon}>
            <Iconfont>&#xe6e7;</Iconfont>
        </div> */}

        <p className={cls.WishMessage}>
            {
                isLoginEmpty?
                <FormattedMessage id="addFavorites" defaultMessage='Add your favorites to your Whishlist now!'/>:
                <FormattedMessage id="wishListEmptySignIn" defaultMessage='Wishlist empty. Sign In to view your Wishlist.'/>
            }
            {/* <FormattedMessage id="addFavorites" defaultMessage="Add your favorites to your Wishlist now!" /> */}
        </p>

        <div className={cls.WishBtn}>
            {
                isLoginEmpty ? <React.Fragment>
                    <button onClick={() =>{
                        window.location.href = "/";
                    }}><FormattedMessage id="go_shopping" defaultMessage="Go Shopping" /></button>
                </React.Fragment> : <React.Fragment>
                    <button onClick={onlyCheckoutLoginHandle}><FormattedMessage id="sign_in" defaultMessage="Sign in" /></button>
                </React.Fragment>
            }
        </div>

        <ProductYouLikes
            titleStyle={{marginTop:0, paddingTop:0}}
            titleClass={'titleLine'}
            noBorderTop={true}
            noAddWish={true}
            sensors={{
                resourcepage_title: 'me',
                resource_position: "1",
                resource_type: "4",
                resource_content: "You may also like",
            }}
            />
    </div>
}

const YouLikesRecommend = props =>{
    const { selectType } = props;
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(false);
    const [finished, setFinished] = useState(false);
    const skipRef = useRef(0);

    useEffect(async () =>{
        loadHandle();
    },[]);

    const loadHandle = useCallback(async () =>{
        setLoading(true);
        let products = await fetchMePageYouLikes(skipRef.current).then(response=>{
            const productItems = response?.result?.map(p => ({
                ...p,
                geekoRequsestId: response.requestId,
                geekoExperimentId: response.experimentId,
                layerName: response.layerName,
                trackingRecords: response.trackingRecords
            }))
            return productItems || [];
        }).catch(error=>[])
        setProducts(preValue => [...preValue, ...products]);
        skipRef.current += 20;
        setLoading(false)
        setFinished(!!!products || products?.length < 20);
    }, [])

    return <div className={cls.WishListRecommend} style={props?.style ? props.style : {}}>
        <List 
            request={loadHandle} 
            loading={loading} 
            finished={selectType === "wishlist" || finished} 
            products={products}
            sensors={{
                resourcepage_title: 'me',
                resource_position: '1',
                resource_type: '4',
                resource_content: 'You may also like'
            }} 
            ingoreCard
        />



    </div>
}

const RecentlyProductsRecommend = props =>{
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(false);
    // const [finished, setFinished] = useState(false);
    // const skipRef = useRef(0);
    // const productIdsRef = useRef();

    useEffect(async () =>{
        // productIdsRef.current = Cache.get("recently_view_products");
        try {
            let productIds = Cache.get("recently_view_products");
            if(productIds?.length > 0){
                setLoading(true);
                let products = await getByProductIds({ productIds: productIds.join(",") }).then(response=>{
                    const productItems = response?.result?.map(p => ({
                        ...p,
                        geekoRequsestId: response.requestId,
                        geekoExperimentId: response.experimentId,
                        layerName: response.layerName,
                        trackingRecords: response.trackingRecords
                    }))
                    return productItems || [];
                }).catch(error=>[]);
                setProducts(preValue => [...preValue, ...products]);
                setLoading(false);
            }
        } catch (error) {
            console.log('error', error);
        }
    },[]);

    // const loadHandle = useCallback(async () =>{
    //     setLoading(true);
    //     // let productIds = productIdsRef.current.slice(skipRef.current, 20 * 2);
    //     if(productIds?.length > 0){
            
            
    //         products?.length >= 20 && (skipRef.current += 20);
    //         setFinished(!!!products || products?.length < 20);
    //     }else{
    //         setFinished(true);
    //     }
    //     setLoading(false)
    // }, [])

    return <div className={cls.WishListRecommend} style={props?.style ? props.style : {}}>
        <List 
            loading={loading} 
            finished={true} 
            products={products} 
            sensors={{
                resourcepage_title: 'me',
                resource_position: '1',
                resource_type: '25',
                resource_content: 'recently view'
            }} 
            hideFinishedTxt 
            ingoreCard
        />

        {
            !loading && products?.length <= 0 && <RecentlyViewEmpty />
        }
    </div>
}

const WishListRecommend = props =>{
    const { selectType } = props;
    const dispatch = useDispatch();
    const pageCustomer = useSelector(state=>state.pageCustomer);
    const { wishListFilterResult, wishListFinished, wishListLoading } = pageCustomer;

    useEffect(async () =>{
        if(!wishListFilterResult || wishListFilterResult?.length <= 0){
            // loadHandle();
            await dispatch(action_init_wishlist({limit:20}))
        }
    },[]);

    const loadHandle = useCallback(_.debounce(async () =>{
        dispatch(action_append_wishlist({limit:20}));
    }, 400), []);

    return <div className={cls.WishListRecommend} style={props?.style ? props.style : {}}>
        <List 
            request={loadHandle} 
            finished={selectType === "youlikes" || wishListFinished} 
            loading={wishListLoading}
            products={wishListFilterResult}
            sensors={{
                resourcepage_title: 'me',
                resource_position: '1',
                resource_type: '11',
                resource_content: 'wishlist'
            }}
            ingoreCard
            isWishList
            hideFinishedTxt={wishListFilterResult?.length === 0 && wishListFinished}
        />

        {
            wishListFilterResult?.length === 0 && wishListFinished && <WishListNotLogin isLoginEmpty />
        }
    </div>
}

export default props =>{
    useStyles(cls);
    const { isLogin, onlyCheckoutLoginHandle } = props;
    const [selectType, setSelectType] = useState("wishlist");
    const [initShow, setInitShow] = useState(false);

    return <div className={cls.UserRecommed}>
        <div className={cls.Hd}>
            <div 
                className={`${cls.TitleItem} ${selectType === "wishlist" ? cls.Active : ""}`}
                onClick={()=>setSelectType("wishlist")}
            >
                <span><FormattedMessage id="wishlist" defaultMessage="Wishlist" /></span>
            </div>

            <div 
                className={`${cls.TitleItem} ${selectType === "youlikes" ? cls.Active : ""}`}
                onClick={()=>{setSelectType("youlikes");setInitShow(true);}}
            >
                <span><FormattedMessage id="recently_viewed" defaultMessage="Recently Viewed" /></span>
            </div>
        </div>

        <div className={cls.Bd}>
            <div style={{ display:`${selectType === "wishlist" ? "block" : "none"}` }}>
                {
                    isLogin ? <WishListRecommend {...props} selectType={selectType}  /> : <WishListNotLogin onlyCheckoutLoginHandle={onlyCheckoutLoginHandle} />
                }
            </div>
            

            {
                initShow && <RecentlyProductsRecommend {...props} selectType={selectType} style={{ display:`${selectType !== "wishlist" ? "block" : "none"}` }} />
            }
        </div>
    </div>
}